import { describeResource } from '@siteless/resource';
import { z } from 'zod';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

let oneUserFavoritesResource = z.union([
  z.null(),
  z.array(
    z.object({
      type: z.union([z.literal('person'), z.literal('film')]),
      key: z.string(),
    }),
  ),
]);

export let OneUserFavoritesResource = describeResource(
  'OneUserFavoritesResource',
  {
    get: async (userId?: string) => {
      if (!userId) return null;

      let userData =
        (await getDoc(doc(database, 'users', userId))).data() || null;

      return oneUserFavoritesResource.parse(userData?.favorites?.[thisOscarsYear] || null);
    },
  },
);
